<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="活动名称">
            <el-input
              v-model="queryForm.name"
              placeholder="请输入活动名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryForm.status"
              clearable
              filterable
              placeholder="请选择活动状态"
            >
              <el-option
                v-for="item in alvType"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" type="success" v-hasPermi="['Island:prize:add']"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="营销编号"
          prop="id"
        />
        <el-table-column
          align="center"
          label="5.0景区"
          prop="five_company_name"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="活动名称"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="奖品总数量"
          prop="five_activity_num"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="剩余数量"
          prop="redemption_codes_num"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="主图"
        >
          <template #default="{ row }">
            <!-- <img class="img-style" :src="row.banner_pic" alt=""/> -->
             <el-image 
              style="width: 100px; height: 100px"
              :src="row.banner_pic" 
              v-if="row.banner_pic"
              :preview-src-list="[row.banner_pic]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="finish_time"
          label="开始日期"
        >
          <template slot-scope="scope">
            {{ transTime(scope.row.start_time) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="结束日期"
        >
          <template slot-scope="scope">
            {{ transTime(scope.row.end_time) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
        >
          <template slot-scope="scope">
            {{ transTime(scope.row.insert_time) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="排序"
          prop="order_by"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
        >
          <template #default="{ row }">
            <span v-if="row.is_available == 1">上架</span>
            <span v-if="row.is_available == 0">下架</span>
          </template>
        </el-table-column>
        <el-table-column width="400px" align="center" label="操作">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:prize:edit']"
              @click="handEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="info"
              v-hasPermi="['Island:prize:times']"
              @click="handleTimes(row)"
            >
              次数获取列表
            </el-button>
            <el-button
              size="small"
              type="warning"
              v-hasPermi="['Island:prize:result']"
              @click="handleResult(row)"
            >
              抽奖结果列表
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:prize:delete']"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getActivityApi, delActivityApi, getZeusCompanyApi } from "@/api/radio"
import { transTime } from "@/utils/transTime"
export default {
  name: 'prize',
  data() {
    return {
      transTime,
      alvType: [
        {
          id: '1',
          label: "上架"
        },
        {
          id: '0',
          label: '下架'
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        page: 1,
        pageSize: 10,
        status: null,
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        name: '',
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: '',
      storeList: [],
    };
  },
  created() {
    this.getStoreList()
  },
  mounted() {},

  methods: {
    // 获取5.0景区列表
    getStoreList() {
      getZeusCompanyApi()
        .then((res) => {
          if(res && res.data){
            this.storeList = res.data; // 全部的5.0景区数据
          }
          this.fetchData()
        })
        .catch((e) => {
          console.log(e);
        });
    },
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      // 查询
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
      sessionStorage.setItem('departStore', JSON.stringify(this.storeList))
      this.$router.push({
        path: "/depart",
        query: {
          type: 'add',
          length: this.tableData.length ? this.tableData[0].order_by : 0
          // storeList: JSON.stringify(this.storeList)
        }
      })
    },
    handEdit(row){
      sessionStorage.setItem('depart', JSON.stringify(row))
      sessionStorage.setItem('departStore', JSON.stringify(this.storeList))
      this.$router.push({
        path: "/depart",
        query: {
          type: 'edit',
          length: this.tableData.length ? this.tableData[0].order_by : 0
          // row: JSON.stringify(row),
          // storeList: JSON.stringify(this.storeList)
        }
      })
    },
    handleTimes(row){
      sessionStorage.setItem('numlist', JSON.stringify(row))
      this.$router.push({
        path: "/numlist"
      })
    },
    handleResult(row){
      sessionStorage.setItem('resultlist', JSON.stringify(row))
      this.$router.push({
        path: "/resultlist"
      })
    },
    handleDelete(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delActivityApi({ id: row.id }).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        })
      })
    },
    async fetchData() {
      let params = {
        name: this.queryForm.name,
        start: this.start,
        end: this.end,
        status: this.queryForm.status ? Number(this.queryForm.status) : -1,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      await getActivityApi(params)
        .then((res) => {
          if (res && res.code) {
            let data = res.data.data_list
            this.total = res.data.total_record // 总共数量
            data.forEach(item => { 
              this.storeList.forEach(key => {
                if(key.storeId == item.five_company_id){
                  item.five_company_name = key.storeName
                }
              })
            })
            this.tableData = data
            console.log(this.storeList, this.tableData)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>

.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.img-style{
  width: 100px;
  height: 100px;
  object-fit: cover;
}

</style>